import React from 'react';
import { PrivacyType, PRIVACY_LINKS } from '@/newcar/ui/contract/config';
import { StandardProps } from '@/newcar/ui/contract';
import * as styles from './index.module.styl';

const privacyTypes: PrivacyType[] = [
  'terms',
  'privacy',
  'agreement',
];

// 申込みフォームの各規約や同意事項リンク
export default function PrivacyLinks(props: StandardProps): JSX.Element {
  const {
    className,
  } = props;
  const links = privacyTypes.map((privacyType) => (
    <>
      <a
        key={`link_${privacyType}`}
        href={PRIVACY_LINKS[privacyType].href}
        target="_blank"
        rel="noreferrer"
        className={`has-text-link ${styles.hasUnderline}`}
        data-gtm={PRIVACY_LINKS[privacyType].gtm}
      >
        {PRIVACY_LINKS[privacyType].label}
      </a>
      <>{PRIVACY_LINKS[privacyType].gap}</>
    </>
  ));
  return <p className={`${className} is-mobile has-text-centered`}>{links}</p>;
}
